import styled, { css } from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;
`;

export const SliderContainer = styled.div`
  flex: 1;
  position: relative;
`;

export const SliderTicks = styled.datalist`
  appearance: none;
  display: flex;
  position: absolute;
  width: 100%;
`;

export const SliderTick = styled.option<{ $left: number; $width: number }>`
  border: 1px solid ${({ theme }) => theme.color.ui2};
  ${({ theme }) => theme.font.t4};
  font-size: 9px;
  left: ${({ $left }) => $left}px;
  padding: 0px;
  position: absolute;
  top: 7px;
  width: ${({ $width }) => $width}px;
`;

export const SliderTickLabel = styled.div<{ $left: number; $width: number }>`
  ${({ theme: { font } }) => font.t4};
  align-items: center;
  height: 16px;
  justify-content: center;
  left: ${({ $left }) => $left}px;
  position: absolute;
  text-align: center;
  top: 23.5px;
  width: ${({ $width }) => $width}px;
`;

export const SliderLabel = styled.div`
  ${({ theme }) => theme.font.t4}
  padding-left: 4px;
  padding-right: 4px;
`;

const trackStyle = css`
  background-color: ${({ theme }) => theme.color.ui2};
  height: 1px;
  width: 100%;
`;

const thumbStyle = (value: number, step: number, numUnits: number, inputWidth: number) => {
  const pixelsPerUnit = inputWidth / numUnits;
  const remainder = value % step;
  const rounded = Math.round(remainder / step);
  // Round up => go left, round down go right
  const units = rounded === 1 ? -(step - remainder) : remainder;
  const translateX = units * pixelsPerUnit;

  return css`
    -webkit-appearance: none;
    appearance: none;
    background-color: ${({ theme }) => theme.color.ui7};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.color.s1};
    height: 9px;
    transform: ${remainder === 0
      ? 'translateY(calc(-50% + 1px))'
      : `translate(${translateX}px, calc(-50% + 1px))`};
    width: 9px;
    :active {
      background: ${({ theme }) => theme.color.s2};
      cursor: grabbing;
    }
    :hover {
      border: 1px solid ${({ theme }) => theme.color.s2};
      box-shadow: 0px 0px 2px ${({ theme }) => theme.color.s2};
      cursor: pointer;
    }
  `;
};

const thumbDisabledStyles = css`
  background: ${({ theme }) => theme.color.ui7};
  border: 1px solid ${({ theme }) => theme.color.ui3};
`;

export const SliderInput = styled.input<{
  $totalWidth: number;
  max: number;
  min: number;
  step: number;
  value: number;
}>`
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  width: 100%;

  &::-webkit-slider-thumb {
    ${({ value, min, max, step, $totalWidth }) => thumbStyle(value, step, max - min, $totalWidth)}
  }
  &::-moz-range-thumb {
    ${({ value, min, max, step, $totalWidth }) => thumbStyle(value, step, max - min, $totalWidth)}
  }
  &::-ms-thumb {
    ${({ value, min, max, step, $totalWidth }) => thumbStyle(value, step, max - min, $totalWidth)}
  }

  &::-webkit-slider-runnable-track {
    ${trackStyle}
  }
  &::-moz-range-track {
    ${trackStyle}
  }
  &::-ms-track {
    ${trackStyle}
  }

  &::-moz-range-progress {
  }
  &::-ms-fill-upper {
  }

  &:disabled::-webkit-slider-thumb {
    ${thumbDisabledStyles}
  }
  &:disabled::-moz-range-thumb {
    ${thumbDisabledStyles}
  }
  &:disabled::-ms-thumb {
    ${thumbDisabledStyles}
  }
`;

export const SliderThumbLabel = styled.div<{ $left: number }>`
  align-items: center;
  bottom: 20px;
  color: black;
  display: flex;
  height: 16px;
  justify-content: center;
  left: ${({ $left }) => $left}px;
  position: absolute;
  text-align: center;
  transform: translateX(-50%);
  white-space: nowrap;
  width: 50px;
  ${({ theme }) => theme.font.t5}
`;
